import range from 'lodash/range'
import shuffle from 'lodash/shuffle'

/**
 *
 * @param {SVGElement} svgElement
 * @param {string} selector
 * @param {number} stepDuration
 */
export function svgShuffleAppear(svgElement, selector, stepDuration, delay = 0) {
  /** @type {NodeListOf<SVGElement>} */
  const shapes = svgElement.querySelectorAll(selector)
  const count = shapes.length

  // Hide them all
  shapes.forEach((s) => s.setAttribute('fill-opacity', 0))

  const shuffledIndices = shuffle(range(count))
  const animateShape = function animateShape(i = 0) {
    const index = shuffledIndices[i]
    shapes.item(index).setAttribute('fill-opacity', 1)
    if (i < count) window.setTimeout(() => animateShape(i + 1), stepDuration)
  }

  window.setTimeout(animateShape, delay)
}

/**
 *
 * @param {SVGElement} svgElement
 * @param {string} selector
 * @param {number} stepDuration
 */
export function svgShuffleIndices(svgElement, selector) {
  /** @type {NodeListOf<SVGElement>} */
  const shapes = svgElement.querySelectorAll(selector)
  const count = shapes.length

  const shuffledIndices = shuffle(range(count))
  shuffledIndices.forEach((position, index) => {
    const shape = shapes.item(position)
    const style = `--shape-index: ${index};` + (shape.hasAttribute('style') ? ` ${shape.getAttribute('style')}` : '')
    shape.setAttribute('style', style)
  })

  svgElement.classList.add('is-animated')
}
